import { UseTranslationResponse } from "react-i18next";

export class ApiError extends Error {
  public internalCode: number;
  public httpCode: number;

  constructor(response: unknown, httpCode: number) {
    super();

    this.internalCode = this.extractInternalCode(response);
    this.httpCode = httpCode;
  }

  private extractInternalCode(response: unknown): number {
    if (
      response != null &&
      typeof response === "object" &&
      "internalCode" in response &&
      response.internalCode != null &&
      typeof response.internalCode === "number"
    ) {
      return response.internalCode;
    }
    return 0;
  }
}

export const extractErrorDescription = (
  error: unknown,
  t: UseTranslationResponse<[string], undefined>
): string => {
  const prefix = "error:";

  if (error instanceof ApiError) {
    const key = "bitbang.internal_code." + error.internalCode.toString();
    if (t.i18n.exists(prefix + key)) return t.t(prefix + key);
  }

  const defaultKey = "bitbang.internal_code.default";
  const defaultTranslation = t.t(prefix + defaultKey);

  return defaultTranslation !== defaultKey
    ? defaultTranslation
    : "Error : translation text not loaded.";
};
